import { useFormContext } from 'react-hook-form';
import { FormSwitch } from 'redesign';
import { getRequiredMessage } from './shared';
import { IsTempworkOrtApplicableContext, Props } from './is-ort-applicable.types';

export const IsTempworkOrtApplicableSwitch = (props: Props) => {
  const { control } = useFormContext<IsTempworkOrtApplicableContext>();
  const label = 'ORT toegepast';
  const requiredMessage = getRequiredMessage(label);
  const name = 'isTempworkOrtApplicable';

  return (
    <FormSwitch
      name={name}
      control={control}
      label={label}
      disabled={props.disabled}
      rules={props.required ? { required: requiredMessage } : undefined}
    />
  );
};
